// 投诉风险模块常量与格式化工具

// 无风险数据时的兜底档位：complaintTendency 或其 current 缺失时入口展示默认文字色、无箭头、不可点击
export const RISK_LEVEL_NONE = 'NONE'

// 沟通与行为卡片「投诉风险」入口条目的风险文字颜色
export const COMPLAINT_RISK_COLOR = {
  LOW: '#02C5A2',
  MEDIUM: '#FC8801',
  HIGH: '#F45959',
  NONE: '#031D4A'
}

// 风险等级默认文案：riskLabel 缺失时按等级兜底
const RISK_LEVEL_TEXT = {
  LOW: '低风险',
  MEDIUM: '中风险',
  HIGH: '高风险',
  NONE: '暂无'
}

// 记录弹窗顶部提示条文案与配色（LOW 与 MEDIUM 同色系为产品刻意配置）
export const COMPLAINT_TIP_CONFIG = {
  HIGH: {
    text: '该患者投诉倾向高，服务需要关注，风险识别记录如下：',
    color: '#FF2A2A',
    bg: '#FEECEC'
  },
  MEDIUM: {
    text: '该患者投诉倾向中等，服务需要关注，风险识别记录如下：',
    color: '#FC8801',
    bg: '#FCF4EA'
  },
  LOW: {
    text: '该患者有轻微投诉倾向，服务需要关注，风险识别记录如下：',
    color: '#FC8801',
    bg: '#FCF4EA'
  }
}

// 投诉场景来源枚举
export const SOURCE_LABEL_ENUM = {
  1: '三方群聊/私聊',
  2: '微信群聊',
  3: '投诉与建议',
  4: '电话'
}

// 仅投诉与建议来源展示「查看详情」按钮
export const DETAIL_SOURCE_LABEL = 3
// 电话来源展示通话信息
export const CALL_SOURCE_LABEL = 4

// 通话时长格式化：秒数 → X秒 / X分Y秒（整分省略秒），空值兜底 --
export function formatCallDuration(seconds) {
  const value = Number(seconds)
  if (!Number.isFinite(value) || value <= 0) return '--'
  if (value < 60) return `${value}秒`
  const minutes = Math.floor(value / 60)
  const rest = Math.round(value % 60)
  return rest ? `${minutes}分${rest}秒` : `${minutes}分钟`
}

export function getSourceLabelText(sourceLabel) {
  return SOURCE_LABEL_ENUM[sourceLabel] || ''
}

export function getRiskLevelText(riskLevel) {
  return RISK_LEVEL_TEXT[riskLevel] || ''
}

export function getRiskLevelColor(riskLevel) {
  return COMPLAINT_RISK_COLOR[riskLevel] || ''
}

export function getComplaintTipConfig(riskLevel) {
  return COMPLAINT_TIP_CONFIG[riskLevel] || null
}
